import CategoryDetail from "./CategoryDetail";

/** /super_admin/contribution/contribution_history/:id: one category's contributors and payments. */
export default function Contribution_HistoryDetail() {
  return <CategoryDetail />;
}
